<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4269 13.1159H4.57073C2.7855 13.1159 1.33301 11.6578 1.33301 9.87627C1.33301 8.24972 2.53855 6.89697 4.10182 6.66927C4.39467 4.7806 6.03269 3.33398 7.99957 3.33398C9.96646 3.33398 11.6045 4.7806 11.8994 6.66927C13.4608 6.89698 14.6663 8.24989 14.6663 9.87627C14.6663 11.6578 13.214 13.1159 11.4267 13.1159H11.4269ZM4.57073 7.92446C3.49531 7.92446 2.62278 8.799 2.62278 9.87627C2.62278 10.9497 3.49531 11.8242 4.57073 11.8242H11.4269C12.5023 11.8242 13.3767 10.9497 13.3767 9.87627C13.3767 8.799 12.5022 7.92446 11.4269 7.92446H11.3006C10.9448 7.92446 10.6558 7.63749 10.6558 7.27762C10.6558 5.81567 9.46374 4.62359 7.9999 4.62359C6.53419 4.62359 5.34399 5.81567 5.34399 7.27762C5.34399 7.63733 5.05501 7.92446 4.69715 7.92446H4.57073Z"
      fill="#858C9A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.47098 2.86203C2.73133 2.60168 3.15344 2.60168 3.41379 2.86203L14.471 13.9192C14.7313 14.1796 14.7313 14.6017 14.471 14.862C14.2106 15.1224 13.7885 15.1224 13.5282 14.862L2.47098 3.80484C2.21063 3.54449 2.21063 3.12238 2.47098 2.86203Z"
      fill="#858C9A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.99957 2.39007C2.52027 1.86938 3.36449 1.86938 3.88519 2.39007L14.9424 13.4473C15.4631 13.968 15.4631 14.8122 14.9424 15.3329C14.4217 15.8536 13.5775 15.8536 13.0568 15.3329L1.99957 4.27569C1.47887 3.75499 1.47887 2.91077 1.99957 2.39007ZM3.41379 2.86148C3.15344 2.60113 2.73133 2.60113 2.47098 2.86148C2.21063 3.12183 2.21063 3.54394 2.47098 3.80429L13.5282 14.8615C13.7885 15.1218 14.2106 15.1218 14.471 14.8615C14.7313 14.6011 14.7313 14.179 14.471 13.9187L3.41379 2.86148Z"
      fill="white"
    />
  </svg>
</template>
